import React, { Component } from "react";
import dayjs from "dayjs";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { alignProperty } from "@mui/material/styles/cssUtils";
import { s360ConfigService } from "../../Services/S360Config";

class MessageA96 extends Component {
  constructor(props) {
    super(props);
  }

  onSubmit = (e) => {
    this.onMouseLeaveButton(e);

    // this.props.actions.sendMessage(`${this.state.timeSlot}timeRange`);
    this.props.actions.sendMessage(this.state.timeSlot);
  };
  onMouseEnterButton = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
  };

  onMouseLeaveButton = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = s360ConfigService.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
  };
  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "20px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
    };
    return styleData;
    // return {
    //   background: s360ConfigService.config.designDetails.recieverMessageColor,
    //    fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //    fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //    color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //    marginLeft: '15px'
    //   }
  };
  render() {
    const data = isNullOrUndefined(
      this?.props?.entry && this?.props?.entry?.text_data?.data
    )
      ? []
      : this?.props?.entry && this?.props?.entry?.text_data?.data;
    // console.log(this?.props?.entry?.text_data,"a96 data")
    //    let text =`<img src="https://picsum.photos/id/237/200/300">`
    // if (this.props.entry && this.props.entry.keyword) { data = data; }
    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        {data?.length !== 0 &&
          data.map((oneData) => (
            <button
              disabled={this.props.disabled}
              className={`${this.messageBoxClassName()} btn-check ${this.props.config.designDetails?.hideButtonMargin ? "margin-0" : ""}`}
              onMouseEnter={this.onMouseEnter}
              onMouseLeave={this.onMouseLeave}
              style={this.messageBoxStyle()}
              {...(this.isActiveConversation() && {
                onClick: () => this.onMessageSend(oneData),
              })}
            >
              {oneData.name}
              <br />
            </button>
          ))}
        {this.props.isLastEntry && this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(Math.trunc(this.props.sentTimestamp / 1000))
              .format("DD MMM h:mm a")}
          </div>
        )}
      </div>
    );
  }

  onMouseEnter = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    const designDetails = this.props.config.designDetails;
    e.target.style.color = isNullOrUndefined(
      designDetails.buttonHighlightTextColor
    )
      ? "#f8f5f5"
      : designDetails.buttonHighlightTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonHighlightBackgroundColor
    )
      ? "#2935dd"
      : designDetails.buttonHighlightBackgroundColor;
    e.target.style.borderColor = isNullOrUndefined(
        designDetails.buttonHighlightBorderColor
      )
        ? isNullOrUndefined(designDetails.buttonBorderColor)
          ? "#0092ed"
          : designDetails.buttonBorderColor
        : designDetails.buttonHighlightBorderColor;
  };

  onMouseLeave = (e) => {
    if (!e.target) {
      return;
    }
    // if (e.target.disabled === true) { return }
    const designDetails = this.props.config.designDetails;
    e.target.style.color = isNullOrUndefined(designDetails.buttonTextColor)
      ? "#0092ed"
      : designDetails.buttonTextColor;
    e.target.style.backgroundColor = isNullOrUndefined(
      designDetails.buttonBackgroundColor
    )
      ? "#fff"
      : designDetails.buttonBackgroundColor;
    e.target.style.borderColor = isNullOrUndefined(designDetails.buttonBorderColor)
        ? "#0092ed"
        : designDetails.buttonBorderColor;
  };

  messageTimeClassName = () => {
    return "s360-message-time-received";
    // switch (this.props.message.type) {
    //     // case MessageType.sent: return "s360-message-time-sent";
    //     // case MessageType.received: return "s360-message-time-received";
    //     // case MessageType.info: return "s360-message-time-info";
    //     default: return "";
    // }
  };

  messageBoxClassName = () => {
    //return "s360-message-box-received";
    return `btn btn-chat${this.props.config.designDetails?.hideButtonBoxShadow ? " box-shadow-none" : ""}`;
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-box-sent";
    //     case MessageType.received: return "s360-message-box-received";
    //     case MessageType.info: return "s360-message-box-info";
    //     default: return "";
    // }
  };

  messageContainerClassName = () => {
    return this.props.config.autoFullScreen
    ? "s360-message-cotainer-received-fs"
    : "s360-message-cotainer-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-cotainer-sent";
    //     case MessageType.received: return "s360-message-cotainer-received";
    //     case MessageType.info: return "s360-message-cotainer-info";
    //     default: return "";
    // }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    const designDetials = this.props.config.designDetails;
    let styleData = {
      textAlign: "left",

      // background: config.designDetails.senderMessageColor,
      fontFamily: config.designDetails.SenderMessageFont,
      fontSize: config.designDetails.SenderMessageFontSize,
      borderWidth: "1px",
      borderStyle: "solid",
      // color: config.designDetails.senderMessageFontColor,
      // height:          isNullOrUndefined(designDetials.buttonHeight)          ? "auto" : designDetials.buttonHeight,
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,
      width: isNullOrUndefined(designDetials.buttonWidth)
        ? "fit-content"
        : designDetials.buttonWidth,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(config.designDetails.senderMessageFontColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
      fontWeight: isNullOrUndefined(designDetials.senderFontWeight)
        ? "500"
        : designDetials.senderFontWeight,
    };
    // switch (this.props.message.type) {
    //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
    //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
    return styleData;
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    return {
      fontFamily: config.designDetails.messageFont,
      fontSize: config.designDetails.messageTimeFontSize,
      color: config.designDetails.messageTimeFontColor,
    };
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    // switch (this.props.message.type) {
    //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
  };

  onMessageSend = (oneOption) => {
    var n = document.getElementsByClassName("btn btn-chat");
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      this.onMouseLeave({ target: n[i] });
    }
    this.props.actions.sendMessageWithCode(oneOption.value,{name:oneOption.name,value:oneOption.value});
  };

  isActiveConversation = () => {
    let isClosed =
      (this.props.activeConversation &&
        this.props.activeConversation.active != null &&
        this.props.activeConversation.active !== undefined &&
        this.props.activeConversation.active === false) ||
      this.props.isConversationClosed;
    return !isClosed;
  };
}

export default MessageA96;
